(function () {
  'use strict';
  class Controller {
    constructor() {}
  }
  angular
    .module('approval.updateProduct', [])
    .component('approvalUpdateProduct', {
      controller: Controller,
      templateUrl: 'root/approval/_components/updateProduct/updateProduct-approval.comp.html',
      bindings: {}
    });
}());
